import React, { useState } from 'react';
import { FaUserXmark } from 'react-icons/fa6';
import { useDispatch, useSelector } from 'react-redux';
import Apis from '../../../../../../api';
import { RootState } from '../../../../../../store/rootReducer';
import MessageActions from '../../../../../message/redux/actions';
import TeamManagementActions from '../redux/actions';
import TeamManagementModal from './TeamMangemntModal';
type Props = {
    userUUID: string;
};
const DeleteTeamMember: React.FC<Props> = ({ userUUID }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const investor = useSelector((state: RootState) => state.user.investor);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
    const handleDeleteTeam = () => {
        const investorUUID = investor?.uuid || '';
        if (!userUUID || !investorUUID) {
            return;
        }
        setDeleteLoader(true);
        Apis.deleteTeamMember(investorUUID, userUUID)
            .then(({ data }) => {
                if (data) {
                    dispatch(TeamManagementActions.fetchTeamMembers(investorUUID));
                } else {
                    dispatch(MessageActions.showMessage({ error: true, text: String('Something went Wrong') }));
                }
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: true, text: err }));
            })
            .finally(() => {
                setDeleteLoader(false);
                setOpen(false);
            });
    };
    return (
        <div>
            <FaUserXmark
                onClick={() => {
                    setOpen(true);
                }}
                className="cursor-pointer"
                color="red"
            />
            <TeamManagementModal
                centered={false}
                open={open}
                onOk={() => handleDeleteTeam()}
                onCancel={() => setOpen(false)}
                title=""
                confirmButtonTitle={'Submit'}
                showCancel={true}
                cancelButtonTitle={'Cancel'}
                confirmationLoading={deleteLoader}
            >
                <p className="text-lg WorkSans-Semibold font-bold">Confirmation</p>
                <div className="border-b border mb-4" />
                <p className="text-[#20222B] !font-[Lato] text-sm">Are you sure you want to delete team member? </p>
                <p className="text-[#20222B] WorkSans-Semibold text-sm">Warning: This cannot be undone.</p>
            </TeamManagementModal>
        </div>
    );
};

export default DeleteTeamMember;
